// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login-features {
  font-family: Calibri, sans-serif;

  & img.themed_logo {
    object-fit: contain !important;
    height: 100%;
    width: 100%;
    align-self: center;
  }

  & h1 {
    text-align: center;
    font-size: 2vw;
  }

  & button[type='submit'] {
    margin-top: 1em !important;
    font-family: inherit;
  }
}

button.disabled {
  color: #a9a9a9 !important;
  background-color: #eaeaea !important;
  border-color: #bcbcbc !important;
}

button.as-link {
  border: unset;
  background: unset;
  color: #1eabe3;
  background-color: none;
  font-size: 1.2em;
  text-decoration: underline;
  font-family: inherit;
}

.MuiBox-root,
.MuiFormHelperText-root {
  font-family: Calibri, sans-serif;
}

.MuiFormControl-root {
  width: 100%;
  margin: 11px 0 !important;
}

.progress-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  padding-right: 25px;
  font-family: inherit;

  & .MuiGrid-grid-xs-6,
  & .MuiGrid2-grid-xs-6 {
    width: inherit;
    max-width: inherit;
  }

  & .progress {
    margin: 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/login/login-features.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;;EAEhC;IACE,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;;EAEpB;;IAEE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["#login-features {\n  font-family: Calibri, sans-serif;\n\n  & img.themed_logo {\n    object-fit: contain !important;\n    height: 100%;\n    width: 100%;\n    align-self: center;\n  }\n\n  & h1 {\n    text-align: center;\n    font-size: 2vw;\n  }\n\n  & button[type='submit'] {\n    margin-top: 1em !important;\n    font-family: inherit;\n  }\n}\n\nbutton.disabled {\n  color: #a9a9a9 !important;\n  background-color: #eaeaea !important;\n  border-color: #bcbcbc !important;\n}\n\nbutton.as-link {\n  border: unset;\n  background: unset;\n  color: #1eabe3;\n  background-color: none;\n  font-size: 1.2em;\n  text-decoration: underline;\n  font-family: inherit;\n}\n\n.MuiBox-root,\n.MuiFormHelperText-root {\n  font-family: Calibri, sans-serif;\n}\n\n.MuiFormControl-root {\n  width: 100%;\n  margin: 11px 0 !important;\n}\n\n.progress-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  padding-right: 25px;\n  font-family: inherit;\n\n  & .MuiGrid-grid-xs-6,\n  & .MuiGrid2-grid-xs-6 {\n    width: inherit;\n    max-width: inherit;\n  }\n\n  & .progress {\n    margin: 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
